import { UiAsset } from '@whiz-cart/node-shared/models/erp/uiAsset';

export function connectAssetChildrenWithParents(assets: UiAsset[]): void {
    const byId = new Map(assets.map((asset) => [asset.id, asset]));

    for (const asset of assets) {
        if (asset.parentId) {
            const parent = byId.get(asset.parentId);
            if (parent) {
                parent.children ??= [];
                parent.children.push(asset);
            } else {
                delete asset.parentId;
            }
        }
    }
}
